import { render, staticRenderFns } from "./CorporateTraining.vue?vue&type=template&id=180a7666"
import script from "./CorporateTraining.vue?vue&type=script&lang=js"
export * from "./CorporateTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports